<template>
    <layout theme="white" :canBack="canBack" class="binding-device-wrapper" :title="isTrial?'哺光仪':undefined">
        <ul class="device_info">
            <li><span>设备编号：</span><span>{{deviceDetail.deviceNo}}</span></li>
            <li><span>连接状态：</span><span :class="[deviceDetail.status?deviceDetail.status.toLowerCase():'']">{{deviceDetail.status|statusName}}</span></li>
        </ul>
        <div class="submit-button-wrapper" v-if="!isTrial"><button class="submit-button" :class="{disable: !deviceDetail.id}" @click="handleBanding">确 定 绑 定</button></div>
        <div class="start-button-wrapper" v-else><button @click="handleControlButton" class="button-start" :class="{starting: isOpening}">{{isOpening ? '工作中' : '开启设备'}}</button></div>
        <van-dialog
                v-model="isShowTip"
                title="提示"
                confirmButtonText="确定"
                confirmButtonColor="#57B958"
                @confirm="handleDeleteSubmit"
                show-cancel-button>
            <div class="tip-message">绑定新设备会自动解除与旧设备的绑定，是否确定绑定新设备？</div>
        </van-dialog>
    </layout>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    export default {
        name: "BindingDevice",
        data() {
            return {
                deviceDetail: {},
                canBack: true,
                isShowTip: false
            }
        },
        props: {
            deviceNo: String
        },
        computed: {
            isOpening() {
                return this.deviceDetail.runStatus === 'START';
            },
            isTrial() {
                return this.deviceDetail.type === 1;
            },
            ...mapState([
                'device'
            ])
        },
        methods: {

            handleBanding() {
                if (!this.deviceDetail.id) {
                    return;
                }
                if (this.device.id) {
                    this.isShowTip = true;
                } else {
                    this.netBindingDevice();
                }
            },

            handleControlButton() {
                if (!this.isOpening) {
                    this.netOpenDevice();
                }
            },

            handleDeleteSubmit() {
                this.isShowTip = false;
                this.netBindingDevice();
            },
            /**
             * 获取设备详情
             * @returns {Promise<void>}
             */
            async loadDeviceDetail() {
                const toast = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    let {data} = await this.$req.getDeviceByNo({
                        deviceNo: this.deviceNo
                    });
                    this.deviceDetail = data;
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            async netBindingDevice() {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.bindingDevice({
                        deviceId: this.deviceDetail.id
                    });
                    this.setDevice(this.deviceDetail);
                    if (this.canBack) {
                        this.$router.back();
                    } else {
                        this.$router.replace('/');
                    }
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            /**
             * 开启设备
             * @returns {Promise<void>}
             */
            async netOpenDevice() {
                const toast = this.$toast.loading({
                    message: '请稍等...',
                    forbidClick: true,
                    duration: 0
                });
                try {
                    await this.$req.openTrialDevice({
                        deviceId: this.deviceDetail.id
                    });
                    this.deviceDetail.runStatus = 'START';
                } catch (e) {
                    //TODO
                } finally {
                    toast.clear();
                }
            },

            ...mapMutations([
                'setDevice'
            ])
        },
        filters: {
          statusName(value) {
              if (!value) return '';
              switch (value.toLowerCase()) {
                  case 'offline': return '离线';
                  case 'online': return '在线';
                  case 'unactive': return '未激活';
                  default: return '';
              }
          }
        },
        created() {
            this.canBack = this.$route.query['canBack'] === 'true';
        },
        mounted() {
            this.loadDeviceDetail();
        }
    }
</script>